export const solicitante = 'Solicitante';
export const aprobador = 'Aprobador';
export const notificador = 'Supervisor Notificador'; // Supervisor YPF
export const proveedorNotificador = 'Proveedor Notificador';
export const proveedorAdministrador = 'Proveedor Administrador';
export const consultaServicios = 'Usuario Consulta';
export const responsableProyecto = 'Responsable PEP Proyecto';
export const referenteControlGestion = 'Referente Control de Gestion';
export const referenteCompras = 'Referente Compras';
export const inspector = 'Inspector';

const userRoles = Object.freeze({
  SOLICITANTE: 'Yclick! Solicitante',
  APROBADOR: 'Yclick! Aprobador',
  SUPERVISOR_NOTIFICADOR_YPF: 'Yclick! Supervisor Notificador YPF',
  PROVEEDOR_NOTIFICADOR: 'Yclick! Proveedor Notificador',
  PROVEEDOR_ADMINISTRADOR: 'Yclick! Proveedor Administrador',
  ADMINISTRADOR_CONTRATO: 'Yclick! Administrador de Contrato',
  INSPECTOR: 'Yclick! Inspector',
  REFERENTE_CONTROL_GESTION: 'Yclick! Referente Control de Gestion',
  CONTROL_ERRORES_SAP: 'Yclick! Control de errores SAP',
  USUARIO_CONSULTAS: 'Yclick! Usuario Consulta',
  REFERENTE_COMPRAS: 'Yclick! Referente Compras',
  RESPONSABLE_PEP_PROYECTO: 'Yclick! Responsable PEP Proyecto',
  GERENTE_COMPRA: 'Yclick! Gerente Compra'
});

export default userRoles;
